export default (blob, mimeType, fileName, newWindow = true) => {
    var newBlob = new Blob([blob], { type: mimeType });

    //IE Fix
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
    }

    var data = window.URL.createObjectURL(newBlob);
    var link = document.createElement('a');
    link.style.display = 'none';
    link.href = data;
    link.download = fileName;
    if(newWindow)
        link.target = "_blank";
    
    link.click();

    setTimeout(function () {
        window.URL.revokeObjectURL(data);
        link.remove();
    }, 100)
}